module.exports = __webpack_public_path__ + "img/close.7a0fad41.svg";